/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_User_GroupInputs */

const en_tables_users_user_group = /** @type {(inputs: Tables_Users_User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Group`)
};

const de_tables_users_user_group = /** @type {(inputs: Tables_Users_User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe`)
};

/**
* | output |
* | --- |
* | "User Group" |
*
* @param {Tables_Users_User_GroupInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_user_group = /** @type {((inputs?: Tables_Users_User_GroupInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_User_GroupInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_user_group(inputs)
	return de_tables_users_user_group(inputs)
});